import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPricing from './pricing.reducer';
import { pricingTierEntityAdapter } from './pricing.reducer';
import {
  ICustomer,
  IPricingGroup,
} from '@boma/supplier-portal/shared/entities';

export const selectPricingState = createFeatureSelector<
  fromPricing.PricingState
>(fromPricing.pricingFeatureKey);

const { selectAll } = pricingTierEntityAdapter.getSelectors();
export const getIsLoadingPricingGroups = createSelector(
  selectPricingState,
  (state: fromPricing.PricingState) => !state.loaded
);

export const getPricingGroupedByCustomer = createSelector(
  selectPricingState,
  (state: fromPricing.PricingState) => {
    const pricing = selectAll(state);
    const customers: {
      [key: string]: { customer: ICustomer; pricingGroups: IPricingGroup[] };
    } = {};
    for (let i = 0; i < pricing.length; i++) {
      const p = pricing[i];
      if (!p.customers?.length) {
        customers[i] = { customer: null, pricingGroups: [p] };
        continue;
      }
      for (const c of p.customers) {
        const customerPricingGroups = customers[c.id]?.pricingGroups || [];
        customers[c.id] = {
          customer: c,
          pricingGroups: [...customerPricingGroups, p],
        };
      }
    }
    return Object.values(customers);
  }
);

export const getPricingGroups = createSelector(
  selectPricingState,
  (state: fromPricing.PricingState) => selectAll(state)
);

export const getPricingGroupedByLocation = createSelector(
  selectPricingState,
  (state: fromPricing.PricingState) => selectAll(state)
);

export const getCreatingOrUpdatingPricingGroup = createSelector(
  selectPricingState,
  (state: fromPricing.PricingState) => state.updating
);

export const getSelectedPricingGroup = createSelector(
  selectPricingState,
  (state: fromPricing.PricingState) => state.entities[state.selected.id]
);
